import { Button, Form, Input } from 'antd';

import { getPageQuery } from '../../../utils/utils';
import logo from '../../../assets/logo.png'

import './style.scss'
import { userLogin } from './service';

const Login = props => {
    const _getRedirect = () => {
        let query = getPageQuery()
        return query.redirect
    }

    const onFinish = values => {
        let params = {
            ...values,
            admin: true,
            type: 'pwd',
        }
        userLogin(params).then(res => {
            if (!!res.data?.id) {
                localStorage.setItem('TOKEN', res.data.token)
                localStorage.setItem('USER_INFO', JSON.stringify(res.data))

                let redirect = _getRedirect()
                if (!redirect) redirect = '/9165/9165-admin/user-mng'
                window.location.href = redirect
            }
        })
    };

    const onFinishFailed = errorInfo => {
        // console.log('Failed:', errorInfo);
    };


    return <div className='admin-login-container'>
        <div className='admin-login-title'>
            <img src={logo} alt="" />
            <h1>九尾陆吾后台管理系统</h1>
        </div>
        <div className='admin-login-form'>
            <Form
                name="basic"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                style={{ width: 500 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="用户名/手机"
                    name="userId"
                    rules={[{ required: true, message: '用户名必填！' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="密码"
                    name="password"
                    rules={[{ required: true, message: '密码为必填项！' }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit">
                        登录
                    </Button>
                </Form.Item>
            </Form>
        </div>
    </div>
}

export default Login
